import React, { PureComponent } from 'react';
import T from 'i18n-react';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';
import TextFieldInlineEdit from '../../../../../../TextFieldInlineEdit';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES, ISSUE_BE_ATTRIBUTE_NAMES } from '../../../../../../../constants/issue-attribute-names';
import PropTypes from 'prop-types';
import { isAttributePermitted } from "../../../../../../../utils/issues-helpers";

class DescriptionInlineEdit extends PureComponent {
  render() {
    const { issue, className, styleType, horizontalAlign } = this.props;
    const { description } = issue;
    const isDescriptionEditable = isAttributePermitted(issue, ISSUE_BE_ATTRIBUTE_NAMES[ISSUE_ATTRIBUTE_NAMES.DESCRIPTION]);

    if (!description && !isDescriptionEditable) {
      // No need to show field if have no value and cannot edit;
      return null;
    }
    const noDescriptionText = T.translate('preview.details.noQuestion');
    const label = T.translate('new.question');

    return (
      <TextFieldInlineEdit
        issue={issue}
        label={label}
        placeholder={noDescriptionText}
        attributeName={ISSUE_ATTRIBUTE_NAMES.DESCRIPTION}
        className={className}
        data-testid="DescriptionInlineEdit"
        horizontalAlign={horizontalAlign}
        styleType={styleType}
        linkify
      />
    );
  }
}

DescriptionInlineEdit.displayName = 'DescriptionInlineEdit';

DescriptionInlineEdit.propTypes = {
  issue: issueAttributesType,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  horizontalAlign: PropTypes.bool,
};

export default DescriptionInlineEdit;
